import { environment } from '../../../environments/environment';

/**
 * @description a marker for endpoints from Authentication service
 */
const BASE_URL = environment.apiUrl;
const AUTH_PATH = '/auth';

export const Endpoint = {
  AUTH: {
    register: `${BASE_URL}${AUTH_PATH}/quick-register`,
    login: `${BASE_URL}${AUTH_PATH}/login`,
    refresh_token: `${BASE_URL}${AUTH_PATH}/refresh`,
    sso_token: `${BASE_URL}${AUTH_PATH}/sso-token`,
    logout: `${BASE_URL}${AUTH_PATH}/logout`,
    verify_email: `${BASE_URL}${AUTH_PATH}/verify-email`,
    resend_verification: `${BASE_URL}${AUTH_PATH}/resend-verification`,
    reset_password: `${BASE_URL}${AUTH_PATH}/reset-password`,
    forgot_password: `${BASE_URL}${AUTH_PATH}/forgot-password`,
    onboarding: `${BASE_URL}/auth/complete-profile`,
  },

  PROFILE: {
    tenant: `${BASE_URL}/profile/individual-user`,
    client_user: `${BASE_URL}/profile/business-user`,
  },
  CLIENT: {
    ONBOARDING: {
      item: (clientId: string) => `${BASE_URL}/clients/${clientId}`,
      verifyTurnover: (clientId: string) => `${BASE_URL}/clients/${clientId}/verify-turnover`,
      unverifyTurnover: (clientId: string) => `${BASE_URL}/clients/${clientId}/unverify-turnover`,
    },
    TIN: {
      index: `${BASE_URL}/tin-applications/me`,
    },
    ORDER: {
      index: `${BASE_URL}/clients/me/orders`,
      item: (orderId: string) => `${BASE_URL}/clients/me/orders/${orderId}`,
      orderStatus: (orderId: string) => `${BASE_URL}/orders/${orderId}/status`,
    },
    dashboard: `${BASE_URL}/clients/me/dashboard`,
    services: `${BASE_URL}/services`,
    calculateServicePrice: (serviceId: string) =>
      `${BASE_URL}/services/${serviceId}/calculate-price`,
  },
  DOCUMENT: {
    index: `${BASE_URL}/documents`,
    upload: `${BASE_URL}/documents/upload`,
    list: `${BASE_URL}/documents`,
    item: (documentId: string) => `${BASE_URL}/documents/${documentId}`,
    download: (documentId: string) => `${BASE_URL}/documents/${documentId}/download`,
  },
  PAYMENT: {
    initiate: `${BASE_URL}/payments/initiate`,
    verify: (reference: string) => `${BASE_URL}/payments/verify/${reference}`,
    status: (paymentId: string) => `${BASE_URL}/payments/${paymentId}`,
    order_payments: (orderId: string) => `${BASE_URL}/payments/order/${orderId}`,
  },
  EXTERNAL: {
    PAYSTACK: {
      banks: 'https://api.paystack.co/bank',
    },
  },
  REFERRAL: {
    index: `${BASE_URL}/referrals`,
    create: `${BASE_URL}/referrals`,
    report: `${BASE_URL}/referrals/report/summary`,
    item: (id: string) => `${BASE_URL}/referrals/${id}`,
  },
};
